import { 
  LayoutDashboard, CheckSquare, User, Building2, Calendar, 
  CreditCard, FileText, ClipboardList, Clock, BarChart3, 
  Paperclip, Target, PenTool, Users, Megaphone, 
  BookOpen, Sun, Library, Trophy, BookMarked, ListTodo, Shield
} from "lucide-react";

// ─── Fonts ────────────────────────────────────────────────────────────────────
export const FONTS = `@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=Noto+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&family=DM+Mono:wght@400;500&display=swap');`;

// ─── i18n ─────────────────────────────────────────────────────────────────────
export const T = {
  en: {
    appName: "SchoolCRM", tagline: "Smarter Schools. Happier Parents.",
    login: "Sign In", email: "Email Address", password: "Password",
    role: "Role", forgotPwd: "Forgot password?", signing: "Signing in...",
    welcomeBack: "Welcome back", loginSubtitle: "Sign in to your account to continue",
    superadmin: "Super Admin", admin: "Principal / Admin", teacher: "Teacher", student: "Student", tutor: "Tutor / Home Tutor", individual: "Individual Student",
    dashboard: "Dashboard", attendance: "Attendance", fees: "Fee Manager",
    announcements: "Announcements", exams: "AI Exams", students: "Students",
    staff: "Staff", reports: "Reports", settings: "Settings",
    superadmin: "Super Admin", adminusers: "Admin Users",
    accessMgmt: "Access Management", active: "Active", revoked: "Revoked",
    name: "Full Name", phone: "Phone / WhatsApp", class: "Class",
    cancel: "Cancel", confirm: "Confirm",
    totalStudents: "Total Students", todayAttendance: "Today's Attendance",
    pendingFees: "Fees Pending", papersGenerated: "Papers Generated",
    classAttendance: "Attendance by Class", topDefaulters: "Top Defaulters",
    logout: "Sign Out", language: "Language",
    userId: "User ID", grade: "Grade", section: "Section", actions: "Actions", status: "Status",
    viewProfile: "View Profile", studentProfile: "Student Profile",
    academicInfo: "Academic Performance", attendanceHistory: "Attendance History",
    parentContact: "Parent Contact", totalDue: "Total Due",
    feeHistory: "Fee Ledger", homework: "Homework Log", marks: "Exam Records",
    catAcademic: "Academic Star", catRegular: "Regular", catDefaulter: "Fee Defaulter", catAttention: "Needs Attention",
    markNow: "Mark Now →", sendAll: "Send All Reminders", newAnn: "+ New",
    addStudent: "Add Student", addTeacher: "+ Add Teacher",
    subject: "Subject", doj: "Date of Joining", assignClasses: "Assign Classes",
    absent: "Absent", present: "Present", markAbsent: "Mark Absent", markPresent: "Mark Present",
    proxyDuties: "Proxy Duties (Replacement)", proxyNote: "Covering for absent colleague",
    selfAttendance: "My Attendance", checkIn: "Check In Now", checkInSuccess: "Checked In",
    locationCaptured: "Location Captured", checkInTime: "Check-in Time",
    fetchingLocation: "Fetching location...", locationError: "Location access denied",
    curriculum: "Curriculum & Tests", finishChapter: "Finish Chapter", finished: "Finished",
    inProgress: "In Progress", upcomingTests: "Upcoming Mock Tests", scheduleTest: "Schedule Test",
    uploadMaterial: "Upload PDF/Excel", generateMock: "Generate AI Mock",
    fileNote: "Upload Chapter PDF or Question Sheet to create auto-test",
    myStudents: "My Students", assignHomework: "Assign Homework", dailyTasks: "Daily Tasks",
    selfStudy: "Self Study", addSlot: "+ Add Slot", addTask: "+ Add Task",
    myExams: "My Exams", myFees: "My Fees", myPapers: "Test Papers",
    addExam: "+ Add Exam", addFee: "+ Add Fee", addPaper: "+ Add Paper",
    dailyLog: "Daily Log", teacherLogs: "Teacher Logs", addLog: "+ Add Log",
    timetable: "Timetable", mySchedule: "My Schedule",
    gradebook: "Grade Book", examMgmt: "Exams", leaveManagement: "Leave",
    studyMaterials: "Materials", classReports: "Reports",
    announcements2: "Announcements",
    paperMaker: "Paper Maker", assignments: "Assignments",
  },
  hi: {
    appName: "स्कूलCRM", tagline: "बेहतर स्कूल। खुश अभिभावक।",
    login: "साइन इन", email: "ईमेल पता", password: "पासवर्ड",
    role: "भूमिका", forgotPwd: "पासवर्ड भूल गए?", signing: "लॉग इन हो रहा है...",
    welcomeBack: "वापसी पर स्वागत है", loginSubtitle: "जारी रखने के लिए अपने खाते में साइन इन करें",
    superadmin: "सुपर एडमिन", admin: "प्रधानाचार्य / एडमिन", teacher: "शिक्षक", student: "छात्र", tutor: "ट्यूटर / होम ट्यूटर", individual: "व्यक्तिगत छात्र",
    dashboard: "डैशबोर्ड", attendance: "उपस्थिति", fees: "शुल्क प्रबंधक",
    announcements: "सूचनाएं", exams: "AI परीक्षा", students: "छात्र",
    staff: "स्टाफ", reports: "रिपोर्ट", settings: "सेटिंग",
    accessMgmt: "एक्सेस प्रबंधन", active: "सक्रिय", revoked: "रद्द",
    name: "पूरा नाम", phone: "फ़ोन / WhatsApp", class: "कक्षा",
    cancel: "रद्द करें", confirm: "पुष्टि करें",
    totalStudents: "कुल छात्र", todayAttendance: "आज की उपस्थिति",
    pendingFees: "बकाया शुल्क", papersGenerated: "पेपर तैयार",
    classAttendance: "कक्षावार उपस्थिति", topDefaulters: "शीर्ष बकायेदार",
    logout: "साइन आउट", language: "भाषा",
    userId: "यूज़र ID", grade: "ग्रेड", section: "सेक्शन", actions: "कार्य", status: "स्थिति",
    viewProfile: "प्रोफ़ाइल देखें", studentProfile: "छात्र प्रोफ़ाइल",
    academicInfo: "शैक्षणिक प्रदर्शन", attendanceHistory: "उपस्थिति इतिहास",
    parentContact: "अभिभावक संपर्क", totalDue: "कुल बकाया",
    feeHistory: "शुल्क विवरण", homework: "होमवर्क लॉग", marks: "परीक्षा रिकॉर्ड",
    catAcademic: "एकेडमिक स्टार", catRegular: "नियमित", catDefaulter: "शुल्क बकाया", catAttention: "ध्यान दें",
    markNow: "अभी मार्क करें →", sendAll: "सभी को रिमाइंडर भेजें", newAnn: "+ नई",
    addStudent: "+ छात्र जोड़ें", addTeacher: "+ शिक्षक जोड़ें",
    subject: "विषय", doj: "जुड़ने की तारीख", assignClasses: "कक्षाएं सौंपें",
    absent: "अनुपस्थित", present: "उपस्थित", markAbsent: "अनुपस्थित करें", markPresent: "उपस्थित करें",
    proxyDuties: "प्रॉक्सी ड्यूटी (रिप्लेसमेंट)", proxyNote: "अनुपस्थित सहयोगी की जगह",
    selfAttendance: "मेरी उपस्थिति", checkIn: "अभी हाजिरी लगाएं", checkInSuccess: "उपस्थिति दर्ज",
    locationCaptured: "लोकेशन मिल गई", checkInTime: "हाजिरी का समय",
    fetchingLocation: "लोकेशन खोजी जा रही है...", locationError: "लोकेशन एक्सेस नहीं मिली",
    curriculum: "पाठ्यक्रम और परीक्षा", finishChapter: "चैप्टर खत्म करें", finished: "पूरा हुआ",
    inProgress: "जारी है", upcomingTests: "आगामी मॉक टेस्ट", scheduleTest: "टेस्ट शेड्यूल करें",
    uploadMaterial: "PDF/Excel अपलोड करें", generateMock: "AI मॉक बनाएं",
    fileNote: "ऑटो-टेस्ट बनाने के लिए चैप्टर PDF या प्रश्न पत्र अपलोड करें",
    myStudents: "मेरे छात्र", assignHomework: "होमवर्क दें", dailyTasks: "दैनिक कार्य",
    selfStudy: "स्वयं अध्ययन", addSlot: "+ स्लॉट जोड़ें", addTask: "+ कार्य जोड़ें",
    myExams: "मेरी परीक्षाएं", myFees: "मेरी फीस", myPapers: "टेस्ट पेपर",
    addExam: "+ परीक्षा जोड़ें", addFee: "+ फीस जोड़ें", addPaper: "+ पेपर जोड़ें",
    dailyLog: "दैनिक लॉग", teacherLogs: "शिक्षक लॉग", addLog: "+ लॉग जोड़ें",
    timetable: "समय सारणी", mySchedule: "मेरा शेड्यूल",
    gradebook: "ग्रेड बुक", examMgmt: "परीक्षा", leaveManagement: "छुट्टी",
    studyMaterials: "सामग्री", classReports: "रिपोर्ट",
    announcements2: "सूचनाएं",
    paperMaker: "पेपर बनाएं", assignments: "असाइनमेंट",
  },
};

// ─── Domain List Fallbacks ────────────────────────────────────────────────────
// Prefer useSchoolConfig(user) which loads these dynamically from the DB.
// These are kept only as fallbacks when school config is not yet loaded.
export const SUBJECTS = [
  "Mathematics", "Science", "English", "Hindi",
  "Social Studies", "Computer Science",
];

export const EXAM_TYPES = ["Unit Test 1", "Unit Test 2", "Half Yearly", "Yearly", "Class Test"];

export const CLASS_LIST = [
  "5A","5B","5C","5D","6A","6B","6C","6D",
  "7A","7B","7C","7D","8A","8B","8C","8D",
  "9A","9B","9C","9D","10A","10B","10C","10D",
  "11A","11B","11C","11D","12A","12B","12C","12D",
];

// ─── Nav Item Definitions (per role) ─────────────────────────────────────────
export const buildNavItems = (t) => ({
  admin: [
    { id: "dashboard",    ico: LayoutDashboard, lbl: t.dashboard },
    { id: "attendance",   ico: CheckSquare,     lbl: t.attendance },
    { id: "students",     ico: User,            lbl: t.students },
    { id: "staff",        ico: Building2,       lbl: t.staff },
    { id: "timetable",    ico: Calendar,        lbl: t.timetable },
    { id: "fees",         ico: CreditCard,      lbl: t.fees },
    { id: "feestructures", ico: FileText,       lbl: "Fee Structures" },
    { id: "teacherlogs",    ico: ClipboardList,   lbl: t.teacherLogs },
    { id: "announcements",  ico: Megaphone,       lbl: t.announcements },
    { id: "schooltimings",  ico: Clock,           lbl: "School Timings" },
    { id: "reports",        ico: BarChart3,       lbl: t.reports },
  ],
  saas_admin: [
    { id: "superadmin",   ico: Shield,          lbl: t.saasadmin || "SaaS Admin" },
    { id: "adminusers",   ico: Users,           lbl: t.adminusers },
  ],
  teacher: [
    { id: "dashboard",     ico: LayoutDashboard, lbl: t.dashboard },
    { id: "myschedule",    ico: Calendar,        lbl: t.mySchedule },
    { id: "assignments",   ico: Paperclip,       lbl: t.assignments },
    { id: "exams",         ico: Target,          lbl: t.examMgmt },
    { id: "gradebook",     ico: PenTool,         lbl: t.gradebook },
    { id: "papermaker",    ico: FileText,        lbl: t.paperMaker },
    { id: "students",      ico: Users,           lbl: t.students },
    { id: "fees",          ico: CreditCard,      lbl: t.fees },
    { id: "dailylog",      ico: ClipboardList,   lbl: t.dailyLog },
    { id: "announcements", ico: Megaphone,       lbl: t.announcements2 },
    { id: "materials",     ico: BookOpen,        lbl: t.studyMaterials },
    { id: "reports",       ico: BarChart3,       lbl: t.classReports },
    { id: "leave",         ico: Sun,             lbl: t.leaveManagement },
  ],
  student: [
    { id: "dashboard",     ico: LayoutDashboard, lbl: t.dashboard },
    { id: "announcements", ico: Megaphone,       lbl: t.announcements2 },
    { id: "fees",          ico: CreditCard,      lbl: t.myFees },
    { id: "materials",     ico: Library,         lbl: t.studyMaterials },
    { id: "leaderboard",   ico: Trophy,          lbl: "Leaderboard" },
    { id: "reportcard",    ico: FileText,        lbl: "Report Card" },
    { id: "calendar",      ico: Calendar,        lbl: "Calendar" },
  ],
  coordinator: [
    { id: "dashboard",     ico: LayoutDashboard, lbl: t.dashboard },
    { id: "students",      ico: Users,           lbl: t.students },
    { id: "staff",         ico: Building2,       lbl: t.staff },
    { id: "attendance",    ico: CheckSquare,     lbl: t.attendance },
    { id: "reports",       ico: BarChart3,       lbl: t.reports },
  ],
  tutor: [
    { id: "dashboard",     ico: LayoutDashboard, lbl: t.dashboard },
    { id: "students",      ico: Users,           lbl: t.myStudents },
    { id: "homework",      ico: PenTool,         lbl: t.homework },
    { id: "attendance",    ico: CheckSquare,     lbl: t.attendance },
  ],
  individual: [
    { id: "dashboard",     ico: LayoutDashboard, lbl: t.dashboard },
    { id: "exams",         ico: BarChart3,       lbl: t.myExams },
    { id: "fees",          ico: CreditCard,      lbl: t.myFees },
    { id: "papers",        ico: FileText,        lbl: t.myPapers },
    { id: "selfstudy",     ico: BookMarked,      lbl: t.selfStudy },
    { id: "tasks",         ico: ListTodo,        lbl: t.dailyTasks },
  ],
});
